import { Component, Input } from '@angular/core';

type IconButtonVariant = 'default' | 'danger-flat' | 'light-rest';

@Component({
  selector: 'app-icon-button-component',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent
{
  @Input() icon: string;
  @Input() activeIcon: string;
  @Input() label: string;
  @Input() selected = false;
  @Input() variant: IconButtonVariant = 'default';
  @Input() restBackground: string | null = null;

  get iconSrc(): string
  {
    return `assets/images/SVG/${this.icon}.svg`;
  }

  get activeIconSrc(): string
  {
    return `assets/images/SVG/${this.activeIcon || this.icon}.svg`;
  }

  get hasActiveIcon(): boolean
  {
    return !!this.activeIcon && this.activeIcon !== this.icon;
  }
}
